import { render, staticRenderFns } from "./consolidation.vue?vue&type=template&id=10c4319c&scoped=true"
import script from "./consolidation.vue?vue&type=script&lang=js"
export * from "./consolidation.vue?vue&type=script&lang=js"
import style0 from "./consolidation.vue?vue&type=style&index=0&id=10c4319c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4319c",
  null
  
)

export default component.exports